module.exports = "/assets/79af87ed3dae6d614f854917163449ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AT.png
// module id = 2336
// module chunks = 0